import { render, staticRenderFns } from "./QuestionIcon.vue?vue&type=template&id=98ef3eba&scoped=true"
import script from "./QuestionIcon.vue?vue&type=script&lang=js"
export * from "./QuestionIcon.vue?vue&type=script&lang=js"
import style0 from "./QuestionIcon.vue?vue&type=style&index=0&id=98ef3eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ef3eba",
  null
  
)

export default component.exports